/** Map program level → visual accent */
export const LEVEL_STYLES: Record<number, { hue: number; color: string }> = {
  1: { hue: 260, color: "#a78bfa" },
  2: { hue: 140, color: "#4ade80" },
  3: { hue: 215, color: "#60a5fa" },
  4: { hue: 45, color: "#fbbf24" },
  5: { hue: 290, color: "#e879f9" },
};

export function getLevelStyle(level: number) {
  return LEVEL_STYLES[level] ?? LEVEL_STYLES[1];
}
